function format(raw) {
  const digits = (raw || '').replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
}

export function PhoneInput({ value, onChange, placeholder = '07XX XXX XXXX', error, ...rest }) {
  const display = format(value || '');
  return (
    <input
      className="input"
      dir="ltr"
      style={{ textAlign: 'right', ...(error ? { borderColor: '#EF4444' } : {}) }}
      value={display}
      placeholder={placeholder}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
        onChange?.(digits);
      }}
      {...rest}
    />
  );
}
